import { Component } from '@angular/core';
import { SpinnerService } from 'src/app/core/services/spinner.service';

@Component({
  selector: 'app-spinner',
  template: `
  <div class="overlay" *ngIf="isLoading$ | async">
    <div class="lds-roller"><div></div></div>
    <h1 class="mat-title">Cargando...</h1>
  </div>`,
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent{
  isLoading$ = this.spinnerSvc.isLoading$;

  constructor(private spinnerSvc: SpinnerService) { }

}
